document.addEventListener("DOMContentLoaded", function () {

    const tabs = document.querySelectorAll(".premium-tab");
    const contents = document.querySelectorAll(".premium-products-grid");

    if (!tabs.length) return;

    tabs.forEach(function (tab) {

        tab.addEventListener("click", function () {

            const target = this.getAttribute("data-tab");

            tabs.forEach(function (btn) {
                btn.classList.remove("active");
            });

            this.classList.add("active");

            contents.forEach(function (content) {

                content.classList.remove("active");

                if (content.getAttribute("data-content") === target) {
                    content.classList.add("active");
                }

            });

        });

    });

});